import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";

export default class AboutUs extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="section"
          id="about-us"
          style={{ backgroundColor: "rgba(0,0,0,0.03)" }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="text-center">
                  <h2 className="service-title f-24">ABOUT US</h2>
                  <p className="text-muted mb-0">
                    At Solar Storm, we are a team of energy, design, and
                    construction experts dedicated to helping clients save money
                    while protecting the planet. We’ve been pioneers in solar
                    energy and advocates for socially responsible living.
                    Through our work, we’ve enhanced the well-being and
                    happiness of our clients, employees, and future generations.
                    As Uttar Pradesh’ solar leaders, our mission is simple: save
                    you money while saving the planet. We’re here to help you
                    live well and leave the world better than we found it. Ready
                    to go solar? Give us a call at “
                    <span style={{ fontWeight: "bold" }}>Mobile-nbr</span>” and
                    join the movement for a brighter future."
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
